import React from 'react'
import Home from '../../views/home/Home.tsx'
import Landing from '../../views/landing/Landing'
import Login from '../../views/login/Login'
import { appPathname, pathname } from '../../utils/constants/pathname'
import PageNotFound from '../pageNotFound/PageNotFound'
import Profile from '../../views/profile/Profile'
import NewUserPassword from '../../views/password/NewUserPassword'
import RecoverPassword from '../../views/password/RecoverPassword'
import EmployeePortal from '../../views/employee-portal/EmployeePortal'
import AccountingEntryGenerator from '../../views/accounting-entry/generator/AccountingEntryGenerator.tsx'
import AccountingEntrySalaryConcept from '../../views/accounting-entry/salary-concept/AccountingEntrySalaryConcept.tsx'
import AccountingEntryAnalyticalDistribution from '../../views/accounting-entry/analytical-distribution/AccountingEntryAnalyticalDistribution.tsx'

const routes = {
  // Rutas publicas
  public: [
    {
      path: pathname.LANDING,
      name: 'langing',
      element: <Landing />,
    },
    {
      path: pathname.LOGIN,
      name: 'login',
      element: <Login />,
    },
    {
      path: pathname.NEW_USER_PASSWORD,
      name: 'update-pass',
      element: <NewUserPassword />,
    },
    {
      path: pathname.RECOVER_PASSWORD,
      name: 'recover-pass',
      element: <RecoverPassword />,
    },
  ],

  private: [
    {
      path: appPathname.NOTFOUND_MAIN,
      name: 'login',
      element: <PageNotFound />,
    },
    {
      path: appPathname.NOTFOUND,
      name: 'NotFound',
      element: <PageNotFound />,
    },
    {
      path: appPathname.HOME,
      name: 'home',
      element: <Home />,
    },
    {
      path: appPathname.PROFILE,
      name: 'profile',
      element: <Profile />,
    },
    {
      path: appPathname.EMPLOYEE_PORTAL,
      name: 'employee',
      element: <EmployeePortal />,
    },
    {
      path: appPathname.ACCOUNTING_ENTRY,
      name: 'accountingEntry',
      element: <AccountingEntryGenerator />,
    },
    {
      path: appPathname.ACCOUNTING_ENTRY_EMPLOYEES,
      name: 'accountingEntry.analyticalDistribution',
      element: <AccountingEntryAnalyticalDistribution />,
    },
    {
      path: appPathname.ACCOUNTING_ENTRY_CONCEPTS,
      name: 'salaryConcept',
      element: <AccountingEntrySalaryConcept />,
    },
  ],
}

export default routes
